import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import NotesIcon from '@mui/icons-material/Notes';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import AddIcon from '@mui/icons-material/Add';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import SaveIcon from '@mui/icons-material/Save';

import { Avatar, AvatarGroup, Box, ButtonBase, Divider, FormControl, FormHelperText, Grid, InputAdornment, List, Menu, MenuItem, MenuList, OutlinedInput, Paper, Slide, Stack, TextField, TextareaAutosize, Tooltip } from '@mui/material';
import Service from '../../../util/Service';
import HistoricoCard from './HistoricoCard';
import { blue, green } from '@mui/material/colors';
import VeryEditor from '../../common/EditorVery/VeryEditor2';
import EscolheUserPopover from '../../page/user/EscolheUserPopover';
import ComentarioCard from './ComentarioCard';
import HtmlContent from '../../util/HtmlContent';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import KanbanMaisAcoesMenu from './KanbanMaisAcoesMenu';
import { TYPES } from '../../../util/ServiceWS';

// const BootstrapDialog = styled(Dialog)(({ theme }) => ({
//   '& .MuiDialogContent-root': {
//     padding: theme.spacing(1),
//   },
//   '& .MuiDialogActions-root': {
//     padding: theme.spacing(0),
//   },
// }));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function KanbanCardDialog(props) {
  const {projeto, papeis, temAcessoBasico, open, setOpen, cartao, col, kanban, action, handleMoverCard } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [showComentario, setShowComentario] = React.useState(true);
  const [isFullScreen, setFullScreen] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenuCol = Boolean(anchorEl);
  const [ordem, setOrdem] = React.useState(cartao ? cartao.ordem : 1);
  const [colSelected, setColSelected] = React.useState(col ? col.id : null);
  const [cartaoCorrent, setCartaoCorrent] = React.useState();
  const [editarDescricao, setEditarDescricao] = React.useState(false);
  const [html, setHtml] = React.useState('');
  const [htmlComentario, setHtmlComentario] = React.useState('');
  const [nome, setNome] = React.useState('');
  const [esforco, setEsforco] = React.useState(0);
  const [openBtnEsforco, setOpenBtnEsforco] = React.useState(false);
  const [showCriaComentario, setShowCriaComentario] = React.useState(false);
  const [editarNome, setEditarNome] = React.useState(false);
  const refNome = React.useRef(null);
  const refEditor = React.useRef();
  

  const handleClickMenuCol = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenuCol = () => {
    setAnchorEl(null);
  };
  function handleSelectCol(row) {
    setColSelected(row.id);
  }

  React.useEffect(() => {
    if (cartao) {
      setCartaoCorrent(cartao);
      setHtml(cartao.descricao);
      setEsforco(cartao.esforco);
    }
  }, [cartao])

  React.useEffect(() => {
    if (open) {
      const path = location.pathname;
      const idCartao = params.idCartao;
      if (!idCartao) navigate(path + "/" + cartao.id)
    }
  }, [open])


  const handleClose = () => {
    setOpen(false);
    setShowCriaComentario(false);
    setEditarDescricao(false);
    const idCartao = params.idCartao;
    let path = location.pathname;

    if (path.indexOf("/" + idCartao) >= 0) {
      path = path.replace("/" + idCartao, '');

      navigate(path);
    }
  };

  function handleMoverClick(e) {
    const dado = {
      id: cartao.id,
      idKanban: kanban.id,
      idColuna: colSelected,
      ordem: ordem
    }

    action({
      type: TYPES.cardMove,
      dado: dado
    });
    handleCloseMenuCol();
    setOrdem(0);
  }

  function handleSalvaNome() {
    const dado = {
      nome: nome,
      id: cartaoCorrent.id
    }
    Service.POST("/api/security/projeto/kanban/mudaNome", dado).then(r => {
      if (r.success) {
        setEditarNome(false);
        setCartaoCorrent(r.dado);
        action({
          type: TYPES.cardMudaNome,
          dado: dado
        });
      } else {
        alert(r.msg);
      }
    })
  }
  function handleSalvaEsforco() {
    const dado = {
      id: cartaoCorrent.id,
      esforco: esforco
    }

    Service.POST('/api/security/projeto/kanban/cardSalvaEsforco', dado).then(r => {
      if (r.success) {
        setCartaoCorrent(r.dado);
        setOpenBtnEsforco(false);
      } else {
        alert(r.msg);
      }
    }
    );
  }
  function handleConcluir() {
    const dado = {
      id: cartaoCorrent.id,
      concluido: !cartaoCorrent.concluido
    }

    Service.POST('/api/security/projeto/kanban/cardConcluido', dado).then(r => {
      if (r.success) {
        setCartaoCorrent(r.dado);
      } else {
        alert(r.msg);
      }
    }
    );
  }

  if (!cartaoCorrent) return;

  function handleSalvaComentario() {
    if (refEditor) {
      const comentario = refEditor.current.getHtml();
      const dado = {
        id: cartaoCorrent.id,
        descricao: comentario
      }

      Service.POST('/api/security/projeto/kanban/cardSalvaComentario', dado).then(r => {
        if (r.success) {
          setCartaoCorrent(r.dado);
          setShowCriaComentario(false);
          setHtmlComentario(comentario);
        } else {
          alert(r.msg);
        }
      }
      );
    }
  }
  function handleSalvaDescricao() {

    if (refEditor) {
      const d = refEditor.current.getHtml();
      const dado = {
        id: cartaoCorrent.id,
        descricao: d
      }

      Service.POST('/api/security/projeto/kanban/cardSalvaDescricao', dado).then(r => {
        if (r.success) {
          setHtml(d)
          setCartaoCorrent(r.dado);
          setEditarDescricao(false);
        } else {
          alert(r.msg);
        }
      }
      );
    }
  }
  function handleEsforco(e) {
    if (e.target.value < 0) return;

    setOpenBtnEsforco(cartaoCorrent.esforco != e.target.value);

    setEsforco(e.target.value);
  }
  function handleIncluirMembroCard(user) {
    const dado = {
      id: cartao.id,
      membro: user
    }
    Service.POST('/api/security/projeto/kanban/incluirMembroCartao', dado).then(r => {
      if (r.success) {
        action({
          type: TYPES.cardAddMembro,
          dado: r.dado
        });
        setCartaoCorrent(r.dado);
      } else {
        alert(r.msg);
      }
    })
  }

  function handleMembros() {
    alert('Manutenção dos membros não implementado....')
  }

  function MontaMembros() {
    const membros = cartaoCorrent.membros;
    if (!membros) return;
    return (
      <ButtonBase
        component="label"
        role={undefined}
        tabIndex={-1} // prevent label from tab focus
        aria-label="Avatar image"
        sx={{
          borderRadius: '40px',
          '&:has(:focus-visible)': {
            outline: '2px solid',
            outlineOffset: '2px',
          },
        }}
      >
        <AvatarGroup max={4} onClick={handleMembros}>
          {membros && membros.map((row, id) =>
            <Tooltip key={id} title={row.nome}>
              
              <Avatar sx={{ width: 30, height: 30 }} src={`/api/security/user/avatarImageByLogin/${row.login}`} />
            </Tooltip>
          )}
        </AvatarGroup>
      </ButtonBase>
    )
  }
  function handleCloseMove(dado){
    handleMoverCard(dado);
    handleClose();
  }
  function handleEditarNome() {
    setNome(cartaoCorrent.nome);
    setEditarNome(true);
    setTimeout(() => {
      refNome.current.focus();
    }, 300);
  }

  return (
    // <BootstrapDialog
    //   onClose={handleClose}
    //   aria-labelledby="customized-dialog-title"
    //   open={open}
    //   // maxWidth='lg'
    //   fullWidth={isFullScreen}
    // >
    <Dialog
        fullScreen={isFullScreen}
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        slots={{
          transition: Transition,
        }}
      >
      <DialogTitle id="customized-dialog-title" sx={{ m: 0, p: 2, display: 'flex', width: '98%' }}>
        {/* <Toolbar > */}
        <Button variant="outlined" endIcon={<KeyboardArrowDownIcon />} size='small' 
          onClick={handleClickMenuCol} disabled={!temAcessoBasico}
        >
          {col.nome}
        </Button>

        <TextField
          label="Esforço" size='small' type="number"
          sx={{ ml: 5, width: '15ch' }}
          value={esforco} onChange={handleEsforco}
          slotProps={{
            input: {
              endAdornment: <InputAdornment position="end">Horas</InputAdornment>,
            },
          }}
          variant="outlined"
          disabled={!temAcessoBasico}
        />
        {openBtnEsforco &&
          <Tooltip title="Salvar esforço">
            <IconButton aria-label="Salvar" disabled={!temAcessoBasico}
              onClick={handleSalvaEsforco}
              // size="small" 
              sx={{ color: blue[500] }}
            >
              <SaveIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>}
        <Box component="div" sx={{ flexGrow: 1 }}></Box>
        {cartaoCorrent && MontaMembros()}
        <KanbanMaisAcoesMenu projeto={projeto} papeis={papeis}
          cartao={cartaoCorrent} temAcessoBasico={temAcessoBasico}
          action={action} col={col} handleMoverCard={handleCloseMove} kanban={kanban}
          handleFullScreen={() => setFullScreen( !isFullScreen) }
          />
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 2,
          top: 2,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers sx={{minWidth: '700px'}}>
        <Grid container spacing={0}>
          <Grid size={showComentario?8:12} >
            <Stack direction="row">
              <Tooltip title="Marcar como concluido">
                <IconButton size='small' disabled={!temAcessoBasico}
                  aria-label="close"
                  onClick={handleConcluir}
                  sx={{ width: '40px' }}
                >
                  {cartaoCorrent.concluido ? <RadioButtonCheckedIcon sx={{ color: green[500] }} /> : <RadioButtonUncheckedIcon />}
                </IconButton>
              </Tooltip>
              {!editarNome && <Typography variant='h5' onClick={handleEditarNome}>
                {cartaoCorrent.nome}
              </Typography>}
              {editarNome &&
                <div>
                  <TextField label="Nome" inputRef={refNome}
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                  >
                  </TextField>
                  <Tooltip title="Salvar nome">
                    <IconButton aria-label="Salvar"
                      onClick={handleSalvaNome}
                      // size="small" 
                      sx={{ color: blue[500] }}
                    >
                      <SaveIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </div>
              }
            </Stack>
            <Stack direction="row" sx={{ mt: 2 }} spacing={2}>
              <Button variant="outlined" startIcon={<AddIcon />} size='small' disabled={!temAcessoBasico}>
                Adicionar
              </Button>
              {/* <Button variant="outlined" startIcon={<PersonAddIcon />} size='small'>
                Membros
              </Button> */}
              <EscolheUserPopover 
                membros={cartao.membros} action={handleIncluirMembroCard} lst={kanban.membros} temAcessoBasico={temAcessoBasico}                
                />
              <Button variant="outlined" startIcon={<CheckBoxIcon />} size='small' disabled={!temAcessoBasico}>
                CheckList
              </Button>
              {!showComentario &&
              <Tooltip title="Mostrar histórico">
                  <IconButton size='small' onClick={() => setShowComentario( !showComentario) }
                    aria-label="close" sx={{ width: '40px' }}
                    color='primary'
                  >
                    <Visibility />
                  </IconButton>
                </Tooltip>
              }
            </Stack>
            <div>
                <Tooltip title="Editar descrição">
                  <IconButton size='small' color='primary' disabled={!temAcessoBasico}
                    aria-label="close"
                    onClick={() => setEditarDescricao(!editarDescricao)}
                    sx={{ width: '40px' }}
                  >
                    <NotesIcon />
                  </IconButton>
                </Tooltip>
                {editarDescricao && <Button 
                    // className='edit' 
                    onClick={handleSalvaDescricao} variant='outlined' sx={{ m: 2 }}>Salvar Descrição
                  </Button> }
              </div>
            <Stack direction="row" sx={{ mt: 0 }}>
              
              {!editarDescricao && cartaoCorrent.descricao &&
                <Paper sx={{ 
                    overflow: 'auto', 
                    width: '100%', 
                    maxHeight: '380px' 
                  }}>
                  <HtmlContent htmlString={cartaoCorrent.descricao} edit={true} />
                </Paper>
              }
              {editarDescricao &&
                <Stack name="classeRoot" sx={{ 
                  overflow: 'auto', 
                  // maxWidth: '540px', 
                  maxHeight: '380px',
                  width: '100%',
                }}>
                  
                  <VeryEditor
                    style={{
                      padding: 4, border: '2px solid black', overflow: 'auto', 
                      height: '500px', 
                      width: '100%',
                      minWidth: '700px'
                    }}
                    html={html} setHtml={setHtml} ref={refEditor}
                    staticOnly={true}
                  />
                </Stack>}
            </Stack>
          </Grid>
          { showComentario &&
          <Grid size={4}>
            <Stack direction="row" >
              <InsertCommentIcon />
              <Typography variant='body1' sx={{ ml: 5 }}>
                Comentário e atividade
              </Typography>
              <Box sx={{flexGrow: 1}}>

              </Box>
                <Tooltip title="Ocultar histórico">
                  <IconButton size='small' onClick={() => setShowComentario( !showComentario) }
                    aria-label="close" sx={{ width: '40px' }}
                  >
                    <VisibilityOff />
                  </IconButton>
                </Tooltip>
            </Stack>
            {!showCriaComentario && <div style={{
              border: '1px solid grey', borderRadius: '15px', padding: 8,
              cursor: 'pointer', marginBottom: 5
            }}
              onClick={() => setShowCriaComentario(true)}
            >
              Escrever um comentário...
            </div>}
            {showCriaComentario &&
              <Stack sx={{ overflow: 'auto', maxWidth: '540px', maxHeight: '380px' }}>
                <Button className='edit' onClick={handleSalvaComentario} variant='outlined' sx={{ m: 2 }}>Salvar Comentário</Button>
                <VeryEditor
                  style={{
                    padding: 4, border: '2px solid black', overflow: 'auto', 
                    height: '500px',
                    minWidth:'700px',
                    with: '100%'
                  }}
                  html={htmlComentario} setHtml={setHtmlComentario}
                  ref={refEditor}
                />
              </Stack>
            }
            <List
              sx={{
                width: '100%',
                // maxWidth: 360,
                // bgcolor: 'background.paper',
                position: 'relative',
                overflow: 'auto',
                maxHeight: 400,
                '& ul': { padding: 0 },
              }}
              subheader={<li />}
            >
              {cartaoCorrent && cartaoCorrent.comentario && cartaoCorrent.comentario.length > 0 && cartaoCorrent.comentario.sort((a, b) => b.dt - a.dt).map((row, index) =>
                <ComentarioCard key={index + "-c"} comentario={row} card={cartaoCorrent} setCartao={setCartaoCorrent} />
              )}
              {/* </List> */}
              <Divider />
              {/* <List
              sx={{
                width: '100%',
                // maxWidth: 360,
                bgcolor: 'background.paper',
                position: 'relative',
                overflow: 'auto',
                maxHeight: 300,
                '& ul': { padding: 0 },
              }}
              subheader={<li />}
            > */}
              {cartaoCorrent && cartaoCorrent.historico && cartaoCorrent.historico.length > 0 && cartaoCorrent.historico.sort((a, b) => b.dt - a.dt).map((row, index) =>
                <HistoricoCard key={index + '-h'} historico={row} />
              )}
            </List>
          </Grid>
          }
        </Grid>

      </DialogContent>
      {/* <DialogActions>
        <Button autoFocus onClick={handleClose}>
          Salvar mudanças
        </Button>
      </DialogActions> */}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenuCol}
        onClose={handleCloseMenuCol}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        <Typography align='center' variant='title2' sx={{ m: 2 }} >Mover para coluna</Typography>
        <MenuList dense>
          {kanban && kanban.colunas.map((row, index) => {
            return (
              <MenuItem
                key={index} onClick={() => handleSelectCol(row)}
                selected={row.id === colSelected}
              >
                {row.nome}
              </MenuItem>
            )
          })}
        </MenuList>
        <Divider />
        <Stack
          sx={{
            alignItems: 'center',
            mt: 1
          }}>
          <TextField
            label="Ordem do cartão:"
            type='number'
            size="small"
            sx={{ m: 1, width: '160px' }}
            value={ordem} onChange={(e) => setOrdem(e.target.value > 1 ? e.target.value : 1)}
          />
          <Button variant="outlined" sx={{ width: '80px' }} onClick={handleMoverClick}>
            Mover
          </Button>
        </Stack>
      </Menu>
    </Dialog>
  );
}
